module.exports = __webpack_public_path__ + "static/media/icons.bb657933.svg";